import React from 'react';
import sitemasterLogo from "../../assets/SiteMaster.svg";
const ModernB2BLoading = () => {
  return (
    <div className="h-[80vh] bg-gradient-to-br my-5 from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="text-center space-y-8 max-w-md">
        {/* Logo/Brand Area */}
        <div className="flex items-center justify-center space-x-2 mb-8">
          <img src={sitemasterLogo} alt="Logo" className="h-8 w-auto" />
        </div>

        {/* Main Loading Animation */}
        <div className="relative">
          {/* Outer Ring */}
          <div className="w-16 h-16 mx-auto border-4 border-slate-200 rounded-full relative">
            <div className="absolute inset-0 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"></div>
          </div>
          
          {/* Inner Pulse */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-6 h-6 bg-blue-600 rounded-full animate-pulse opacity-60"></div>
          </div>
        </div>

        {/* Loading Text */}
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-slate-800">
            Loading your workspace
          </h2>
          <p className="text-slate-500 text-sm">
            Setting up your dashboard and preferences...
          </p>
        </div>

        {/* Progress Dots */}
        <div className="flex justify-center space-x-2">
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>

        {/* Loading Steps (Optional) */}
        <div className="mt-8 space-y-3 text-left max-w-xs mx-auto">
          <div className="flex items-center space-x-3">
            <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
              <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <span className="text-sm text-slate-600">Authentication verified</span>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="w-5 h-5 bg-green-500 rounded-full flex items-center justify-center">
              <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <span className="text-sm text-slate-600">Loading user preferences</span>
          </div>
          
          <div className="flex items-center space-x-3">
            <div className="w-5 h-5 border-2 border-blue-600 rounded-full flex items-center justify-center">
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
            </div>
            <span className="text-sm text-slate-600">Initializing dashboard</span>
          </div>
        </div>

        {/* Footer */}
        <div className="text-xs text-slate-400 mt-8">
          This may take a few moments
        </div>
      </div>
    </div>
  );
};

export default ModernB2BLoading;